export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/number.js
// module id = 1006
// module chunks = 3